import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';

/**
 * Static grid classes for the pricing table layout.
 * Used by skeleton components that don't have access to dynamic tier count.
 * Assumes 4 tiers (the most common case).
 *
 * Mobile: 2 columns (label + 1 visible plan)
 * Desktop: 5 columns (4fr label + 4× 1fr tier)
 */
export const PRICING_GRID = {
  responsive: 'grid-cols-2 lg:grid-cols-[4fr_1fr_1fr_1fr_1fr]'
} as const;
interface FeatureRowSkeletonProps {
  labelWidth?: string;
}

/** Skeleton for a single feature row (no sub-items) */
function FeatureRowSkeleton(t0) {
  const $ = _c(10);
  const {
    labelWidth: t1
  } = t0;
  const labelWidth = t1 === undefined ? "w-36" : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("grid", PRICING_GRID.responsive, "items-center");
    t3 = cn("border-input bg-background flex min-h-14 items-center border-b px-4 lg:px-6", "sticky left-0 z-10 lg:static");
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== labelWidth) {
    t4 = cn("bg-border h-3.5", labelWidth);
    $[2] = labelWidth;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <div className={t3}><Skeleton className={t4} /></div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="border-input flex h-full min-h-14 min-w-0 items-center justify-center border-b px-4 lg:hidden"><Skeleton className="bg-border size-4 shrink-0" /></div>;
    t7 = Array.from({
      length: 4
    }).map(_temp);
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5) {
    t8 = <div className={t2}>{t5}{t6}{t7}</div>;
    $[8] = t5;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}
function _temp(_, i) {
  return <div key={i} className="border-input hidden min-h-14 min-w-0 items-center justify-center border-b px-6 lg:flex"><Skeleton className="bg-border size-4 shrink-0" /></div>;
}
export { FeatureRowSkeleton };